<template>
  <div class="article-filter-drawer">
    <div class="overlay" @click="$emit('close')" />
    <div class="drawer">
      <button class="handle" @click="$emit('close')" />

      <div class="header">
        <h3 class="title">Фильтры</h3>
        <button class="button-clear" @click="$emit('clear')">Сбросить фильтры</button>
      </div>

      <div class="body">
        <slot />
      </div>

      <BaseButton name="Применить фильтр" @click="$emit('close')" />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { BaseButton } from '~/components/base-ui/buttons'

  defineEmits<{
    (e: 'close' | 'clear'): void
  }>()
</script>

<style lang="scss" scoped>
  .article-filter-drawer {
    z-index: 60;
    position: fixed;
    top: 0;
    left: 0;
    @extend %flex-column;

    justify-content: flex-end;
    width: 100%;
    height: 100%;

    > .overlay {
      z-index: 5;
      position: absolute;
      inset: 0;
      opacity: 0.35;
      background-color: $color-potato-90;
    }

    > .drawer {
      z-index: 10;
      @extend %flex-column;

      max-height: 85vh;
      padding: 0 40px 32px;
      border-radius: 20px 20px 0 0;
      background-color: $color-default-white;

      @include vp-767 {
        padding: 0 16px 32px;
      }

      > .handle {
        margin: 24px auto;
        width: 50px;
        height: 4px;
        border-radius: 4px;
        background-color: $color-potato-50;
        border: none;
        cursor: pointer;
      }

      > .header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 32px;

        @include vp-767 {
          margin-bottom: 24px;
        }

        > .title {
          font-size: 20px;
          font-weight: 500;
          margin: 0;
        }

        > .button-clear {
          font-size: 16px;
          color: $color-potato-50;
          text-decoration: underline;
          background: none;
          border: none;
          cursor: pointer;
        }
      }

      > .body {
        @extend %flex-column;

        flex-grow: 1;
        gap: 16px;
        overflow-y: auto;
      }

      > :deep(.svoi-button) {
        margin: 32px auto 0;
        width: 100%;
        background-color: $color-kiwi-50;
      }
    }
  }
</style>
